module.exports = __webpack_public_path__ + "static/media/Cadastro_LITpass.dc61eea4.png";